// Lightweight i18n - UI labels for EN/HI/TE
const STRINGS = {
  en: {
    appName: 'Vedanta Document Intelligence',
    company: 'Sterlite Electric',
    poweredBy: 'POC · Powered by 6-Layer Cost Router',
    signIn: 'Sign In',
    email: 'Email',
    password: 'Password',
    signOut: 'Sign out',
    nav: {
      ask: 'Ask a question',
      documents: 'Document Library',
      dept_dashboard: 'Department Cost',
      dept_faqs: 'FAQ Approval Queue',
      dept_audit: 'Query Audit Log',
      admin_dashboard: 'Cost Dashboard',
      admin_routing: 'Model Routing & Keys',
      admin_documents: 'Document Management',
      admin_roi: 'ROI Report',
      admin_audit: 'Full Audit Log',
    },
    role: {
      user: 'Employee',
      dept_head: 'Department Head',
      super_admin: 'Super Admin',
    },
    query: {
      title: 'Ask a question',
      subtitle: 'Get cited answers from documents you are authorised to access. Every answer shows the route taken and the exact cost.',
      placeholder: 'Try: "When does the TCS contract expire?"',
      ask: 'Ask',
      asking: 'Resolving…',
      suggested: 'Suggested',
      route: 'Route',
      cost: 'Cost',
      confidence: 'Confidence',
      model: 'Model',
      elapsed: 'Elapsed',
      sources: 'Cited Sources',
      noSources: 'No source passages were retrieved (the system declined to answer).',
      feedback: 'Was this useful?',
      thanks: 'Thanks for the feedback',
      reviewWarn: 'Legal / contractual answer — please verify with the cited source before action.',
      free: 'FREE',
      answer: 'Answer',
      translated: 'Translated Answer',
      askLang: 'Answer language',
    },
    common: {
      back: 'Back',
      department: 'Department',
      page: 'Page',
      section: 'Section',
      cancel: 'Cancel',
      approve: 'Approve',
      reject: 'Reject',
      edit: 'Edit',
      saveChanges: 'Save changes',
      export: 'Export',
      upload: 'Upload',
      delete: 'Delete',
      loading: 'Loading…',
      empty: 'Nothing to show yet.',
      total: 'Total',
      today: 'Today',
      last30: 'Last 30 days',
    },
  },
  hi: {
    appName: 'Vedanta Document Intelligence',
    company: 'Sterlite Electric',
    poweredBy: 'POC · 6-स्तरीय कॉस्ट राउटर द्वारा संचालित',
    signIn: 'साइन इन करें',
    email: 'ईमेल',
    password: 'पासवर्ड',
    signOut: 'साइन आउट',
    nav: {
      ask: 'प्रश्न पूछें',
      documents: 'दस्तावेज़ लाइब्रेरी',
      dept_dashboard: 'विभागीय लागत',
      dept_faqs: 'FAQ अनुमोदन सूची',
      dept_audit: 'क्वेरी ऑडिट लॉग',
      admin_dashboard: 'लागत डैशबोर्ड',
      admin_routing: 'मॉडल रूटिंग व कुंजियाँ',
      admin_documents: 'दस्तावेज़ प्रबंधन',
      admin_roi: 'ROI रिपोर्ट',
      admin_audit: 'पूर्ण ऑडिट लॉग',
    },
    role: { user: 'कर्मचारी', dept_head: 'विभागाध्यक्ष', super_admin: 'सुपर एडमिन' },
    query: {
      title: 'प्रश्न पूछें',
      subtitle: 'अधिकृत दस्तावेज़ों से उद्धरण-सहित उत्तर पाएँ। हर उत्तर के साथ रूट और सटीक लागत दिखती है।',
      placeholder: 'उदाहरण: "TCS कॉन्ट्रैक्ट कब समाप्त होगा?"',
      ask: 'पूछें',
      asking: 'उत्तर खोज रहे हैं…',
      suggested: 'सुझाव',
      route: 'रूट',
      cost: 'लागत',
      confidence: 'विश्वास',
      model: 'मॉडल',
      elapsed: 'समय',
      sources: 'उद्धृत स्रोत',
      noSources: 'कोई स्रोत नहीं मिला।',
      feedback: 'क्या यह उपयोगी था?',
      thanks: 'प्रतिक्रिया के लिए धन्यवाद',
      reviewWarn: 'विधिक / अनुबंधीय उत्तर — कार्रवाई से पूर्व स्रोत की पुष्टि करें।',
      free: 'निःशुल्क',
      answer: 'उत्तर',
      translated: 'अनूदित उत्तर',
      askLang: 'उत्तर की भाषा',
    },
    common: {
      back: 'वापस', department: 'विभाग', page: 'पृष्ठ', section: 'अनुभाग',
      cancel: 'रद्द', approve: 'स्वीकृत', reject: 'अस्वीकार', edit: 'संपादित',
      saveChanges: 'परिवर्तन सहेजें', export: 'निर्यात', upload: 'अपलोड',
      delete: 'हटाएँ', loading: 'लोड हो रहा है…', empty: 'अभी कुछ नहीं।',
      total: 'कुल', today: 'आज', last30: 'पिछले 30 दिन',
    },
  },
  te: {
    appName: 'Vedanta Document Intelligence',
    company: 'Sterlite Electric',
    poweredBy: 'POC · 6-లేయర్ ఖర్చు రూటర్‌తో',
    signIn: 'సైన్ ఇన్',
    email: 'ఇమెయిల్',
    password: 'పాస్‌వర్డ్',
    signOut: 'సైన్ అవుట్',
    nav: {
      ask: 'ప్రశ్న అడగండి',
      documents: 'డాక్యుమెంట్ లైబ్రరీ',
      dept_dashboard: 'డిపార్ట్‌మెంట్ ఖర్చు',
      dept_faqs: 'FAQ ఆమోద జాబితా',
      dept_audit: 'క్వెరీ ఆడిట్ లాగ్',
      admin_dashboard: 'ఖర్చు డాష్‌బోర్డ్',
      admin_routing: 'మోడల్ రూటింగ్ & కీలు',
      admin_documents: 'డాక్యుమెంట్ నిర్వహణ',
      admin_roi: 'ROI నివేదిక',
      admin_audit: 'పూర్తి ఆడిట్ లాగ్',
    },
    role: { user: 'ఉద్యోగి', dept_head: 'డిపార్ట్‌మెంట్ హెడ్', super_admin: 'సూపర్ అడ్మిన్' },
    query: {
      title: 'ప్రశ్న అడగండి',
      subtitle: 'మీకు అనుమతి ఉన్న పత్రాల నుండి ఉదహరణలతో సహా సమాధానాలు పొందండి. ప్రతి సమాధానంలో రూట్ మరియు ఖచ్చితమైన ఖర్చు కనిపిస్తుంది.',
      placeholder: 'ఉదా: "TCS కాంట్రాక్ట్ ఎప్పుడు ముగుస్తుంది?"',
      ask: 'అడగండి',
      asking: 'పరిష్కరిస్తోంది…',
      suggested: 'సూచనలు',
      route: 'రూట్',
      cost: 'ఖర్చు',
      confidence: 'నమ్మకం',
      model: 'మోడల్',
      elapsed: 'సమయం',
      sources: 'ఉదహరించిన మూలాలు',
      noSources: 'మూలాలు దొరకలేదు.',
      feedback: 'ఇది ఉపయోగకరంగా ఉందా?',
      thanks: 'అభిప్రాయానికి ధన్యవాదాలు',
      reviewWarn: 'చట్టపరమైన / కాంట్రాక్టు సమాధానం — చర్య తీసుకునే ముందు మూలాన్ని ధృవీకరించండి.',
      free: 'ఉచితం',
      answer: 'సమాధానం',
      translated: 'అనువదించిన సమాధానం',
      askLang: 'సమాధాన భాష',
    },
    common: {
      back: 'వెనక్కి', department: 'డిపార్ట్‌మెంట్', page: 'పేజీ', section: 'విభాగం',
      cancel: 'రద్దు', approve: 'ఆమోదించు', reject: 'తిరస్కరించు', edit: 'సవరించు',
      saveChanges: 'మార్పులు సేవ్', export: 'ఎగుమతి', upload: 'అప్‌లోడ్',
      delete: 'తొలగించు', loading: 'లోడవుతోంది…', empty: 'ఇంకా ఏమీ లేదు.',
      total: 'మొత్తం', today: 'నేడు', last30: 'గత 30 రోజులు',
    },
  },
};

export function t(lang, path) {
  const parts = path.split('.');
  let cur = STRINGS[lang] || STRINGS.en;
  for (const p of parts) cur = cur?.[p];
  if (cur == null) {
    cur = STRINGS.en;
    for (const p of parts) cur = cur?.[p];
  }
  return cur ?? path;
}

export const LANGS = [
  { code: 'en', label: 'EN', native: 'English' },
  // Hindi and Telugu temporarily hidden per client request - re-enable when bilingual demo needed.
  // { code: 'hi', label: 'HI', native: 'हिन्दी' },
  // { code: 'te', label: 'TE', native: 'తెలుగు' },
];

export function formatINR(n) {
  if (n === 0 || n === null || n === undefined) return '₹0.00';
  if (n >= 100000) return `₹${(n / 100000).toFixed(2)}L`;
  return `₹${Number(n).toFixed(2)}`;
}
